interface Model {
  id: string;
  name: string;
  [key: string]: any;
}

interface Layer {
  type: string;
  models?: { [key: string]: Model };
}

interface Diagram {
  layers: Layer[] | { [key: string]: Layer };
}

export const correspondenceBoxIdName = (diagram: Diagram | string) => {
  const result: { id: string; name: string }[] = [];
  let parsedDiagram: Diagram;

  if (typeof diagram === "string") {
    try {
      parsedDiagram = JSON.parse(diagram);
    } catch (e) {
      console.log("fail: JSON parsing error", e, diagram);
      return result;
    }
  } else {
    parsedDiagram = diagram;
  }

  if (!parsedDiagram || !parsedDiagram.layers) {
    return result;
  }

  const layers = Array.isArray(parsedDiagram.layers)
    ? parsedDiagram.layers
    : Object.values(parsedDiagram.layers);

  for (const layer of layers) {
    if (layer.type !== "diagram-nodes" || !layer.models) {
      continue;
    }

    console.log("Processing models in diagram-nodes layer:", Object.keys(layer.models));
    for (const model of Object.values(layer.models)) {
      if (model.id && model.name) {
        result.push({ id: model.id, name: model.name });
      }
    }
  }

  return result;
};